import { render, staticRenderFns } from "./ChecklistCheckmark.vue?vue&type=template&id=4001fe4e&scoped=true&"
import script from "./ChecklistCheckmark.vue?vue&type=script&lang=js&"
export * from "./ChecklistCheckmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4001fe4e",
  null
  
)

export default component.exports